import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import FirmSignup from "@/pages/FirmSignup";
import FirmLogin from "@/pages/FirmLogin";
import PortalSelect from "@/pages/PortalSelect";
import SuperAdmin from "@/pages/SuperAdmin";
import AppLayout from "@/components/app/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Parties from "@/pages/Parties";
import PartyDetail from "@/pages/PartyDetail";
import Items from "@/pages/Items";
import TxnModule from "@/components/app/TxnModule";
import Payments from "@/pages/Payments";
import Pending from "@/pages/Pending";
import DeliveryChallanPage from "@/pages/DeliveryChallanPage";
import POS from "@/pages/POS";
import Bank from "@/pages/Bank";
import Cash from "@/pages/Cash";
import Cheques from "@/pages/Cheques";
import Loans from "@/pages/Loans";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import InvoicePrint from "@/pages/InvoicePrint";
import BulkExport from "@/pages/BulkExport";
import UserManual from "@/pages/UserManual";
import PinPromptRoot from "@/components/app/PinPrompt";
import CompanySelect from "@/pages/CompanySelect";
import Pricing from "@/pages/Pricing";
import Warehouses from "@/pages/Warehouses";
import StockTransit from "@/pages/StockTransit";
import PurchaseReminders from "@/pages/PurchaseReminders";
import DataImport from "@/pages/DataImport";
import ShareDoc from "@/pages/ShareDoc";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const loc = useLocation();
  if (!token) return <Navigate to="/firm/login" state={{ from: loc.pathname }} replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <PinPromptRoot />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/firm/signup" element={<FirmSignup />} />
          <Route path="/firm/login" element={<FirmLogin />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/firm/company-select" element={<CompanySelect />} />
          <Route path="/firm/portal" element={<PortalSelect />} />
          <Route path="/super-admin" element={<SuperAdmin />} />
          <Route path="/print/txn/:id" element={<InvoicePrint />} />
          <Route path="/share/:token" element={<ShareDoc />} />

          <Route path="/app" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="parties" element={<Parties />} />
            <Route path="parties/:id" element={<PartyDetail />} />
            <Route path="items" element={<Items />} />
            <Route path="sales" element={<TxnModule txn_type="sale,pos" />} />
            <Route path="estimates" element={<TxnModule txn_type="estimate" />} />
            <Route path="proforma" element={<TxnModule txn_type="proforma" />} />
            <Route path="pay-in" element={<Payments direction="in" />} />
            <Route path="pay-out" element={<Payments direction="out" />} />
            <Route path="pending-orders" element={<Pending mode="orders" />} />
            <Route path="pending-purchase" element={<Pending mode="purchase" />} />
            <Route path="delivery-challan" element={<DeliveryChallanPage />} />
            <Route path="credit-notes" element={<TxnModule txn_type="credit_note" />} />
            <Route path="debit-notes" element={<TxnModule txn_type="debit_note" />} />
            <Route path="pos" element={<POS />} />
            <Route path="purchases" element={<TxnModule txn_type="purchase" />} />
            <Route path="purchase-orders" element={<TxnModule txn_type="purchase_order" />} />
            <Route path="item-requests" element={<PurchaseReminders />} />
            <Route path="warehouses" element={<Warehouses />} />
            <Route path="stock-transit" element={<StockTransit />} />
            <Route path="data-import" element={<DataImport />} />
            <Route path="expenses" element={<TxnModule txn_type="expense" />} />
            <Route path="bank" element={<Bank />} />
            <Route path="cash" element={<Cash />} />
            <Route path="cheques" element={<Cheques />} />
            <Route path="loans" element={<Loans />} />
            <Route path="reports" element={<Reports />} />
            <Route path="bulk-export" element={<BulkExport />} />
            <Route path="manual" element={<UserManual />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
